


export default [
    
    {
        path: '/',
        name: 'loginAdmin',
        component: () => import('./Login')
    },   
    
    {
        path: '/dashboard',
        name: 'dashboardAdmin',
        component: () => import('./Dashboard/Dashboard')
    }, 
    {
        path: '/parceiros',
        name: 'adminParceiros',
        component: () => import('./Parceiros/Parceiros')
    }, 
    {
        path: '/servicos',
        name: 'adminServicos',
        component: () => import('./Servicos/Servicos')
    }, 
    {
        path: '/motoristas',
        name: 'adminMotoristas',
        component: () => import('./Motoristas/Motoristas')
    }, 
    {
        path: '/indicacoes',
        name: 'adminIndicacoes',
        component: () => import('./Indicacoes/Indicacoes')
    }, 
    {
        path: '/usuarios',
        name: 'adminUsuarios',
        component: () => import('./Usuarios/Usuarios')
    },
]